<template>
  <div class="body-wrapper">
    <table-events></table-events>
  </div>
</template>

<script>
import { mapMutations, mapActions } from 'vuex';
import TableEvents from '@/components/table/TableEvents.vue';

export default {
  components: {
    TableEvents
  },
  created() {
    // alerts Community view that card is opened so
    // proper badge is loaded
    this.cardOpened();
    //loading data to table
    this.getEventsByCommunity(this.$store.getters.getActiveCommunity.id);
  },
  methods: {
    ...mapActions('table', ['getEventsByCommunity']),
    ...mapMutations(['cardOpened'])
  }
};
</script>
<style lang="scss" scoped></style>
